module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "dark": !_vm.light,
      "light": _vm.light
    }
  }, [_c('tud-layout')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25441132"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 597
// module chunks = 12